import React from 'react'

export const Vue = () => {
  return (
    <>
      <path
        d="M517.8,866.62l-14.4,24.94L489,866.62H441l62.36,108,62.36-108Z"
        fill="none"
        stroke="#fff"
        strokeWidth="16px"
      />
      <path
        d="M517.8,866.62l-14.4,24.94L489,866.62H441l62.36,108,62.36-108Z"
        fill="#44b783"
      />
      <path
        d="M517.8,866.62l-14.4,24.94L489,866.62H466l37.42,64.81,37.42-64.81Z"
        fill="#364a5e"
      />
    </>
  )
}
